import React, { Component } from "react";
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import filterFactory from "react-bootstrap-table2-filter";
import classnames from "classnames";
import moment from "moment";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { NotificationManager } from "react-notifications";
import { BreadCrumb } from "../../../components/breadcrumb";
import { Loader } from "../../../components/loader";
import { getAvailablePets } from "../../../actions/medicalRecords";
import { getAbandonedCartCustomersViaMedicalRecord, updateAbandonedCartLeadInfo } from "../../../actions/customers";
import { getSubscribedCustomersViaMedicalRecordId } from "../../../actions/subscribeToPet";
import { formatPhoneNumber,convertToTitleCase } from  '../../../utils/helper';
import Switch from "react-switch";

const $ = window.$;
const { SearchBar } = Search;
const LeadType = {
  abandonedCart: "AbandonedCart",
  subscribedCustomers: "SubscribedCustomers",
  quiz: "Quiz",
};

class LeadInformationsList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoadingAbandonedCartCustomers: false,   
      isLoadingSubscribedCustomers:false, 
      isLoadingAvailablePuppy:true, 
      selectedCustomerToExclude: null,
      isWaitingMessagesAvailable: false,
      selectedTab: "AbandonedCart",
      availablePets:[],
      selectedPetId:'',
      abandonedCartCustomers:[],
      subscribedCustomers:[],
      petIdInput: "",
      notes: "",
      abandonedCartNotes:"",
      abandonedCartId:"",
    };
  }

  componentDidMount() {
    this.props.getAvailablePets();
  }

  componentWillReceiveProps = (nextProps) => { 

    if(this.props.leadsAvailablePets !== nextProps.leadsAvailablePets){  
        this.setState({ availablePets : nextProps.leadsAvailablePets, isLoadingAvailablePuppy : false});
    }

    if(this.props.abandonCustomers !== nextProps.abandonCustomers){  
        this.setState({ abandonedCartCustomers : nextProps.abandonCustomers,  isLoadingAbandonedCartCustomers: false,});
    }

    if(this.props.leadSubscribedCustomers !== nextProps.leadSubscribedCustomers){   
       this.setState({ subscribedCustomers : nextProps.leadSubscribedCustomers, isLoadingSubscribedCustomers : false});
    }

    if(nextProps.abandonCustomersError && this.props.abandonCustomersError !== nextProps.abandonCustomersError){
       NotificationManager.error("An error occurred while loading the abandoned cart leads");    
    }

    if( nextProps.leadSubscribedCustomersError && this.props.leadSubscribedCustomersError !== nextProps.leadSubscribedCustomersError){
      NotificationManager.error("An error occurred while loading the subscribed to pet leads");      
    }

    if( nextProps.leadsAvailablePetsError && this.props.leadsAvailablePetsError !== nextProps.leadsAvailablePetsError){
      NotificationManager.error("An error occurred while loading the available pets");      
    }

    if(nextProps.updatedAbandonedCartLead && this.props.updatedAbandonedCartLead !== nextProps.updatedAbandonedCartLead){
      $("#notes-edit-modal").modal("hide"); 
      this.setState({ abandonedCartNotes : "", abandonedCartId:"" });
      let updatedAbandonedCart = nextProps.updatedAbandonedCartLead;      
      this.props.getAbandonedCartCustomersViaMedicalRecord(updatedAbandonedCart.MedicalRecordId);
      NotificationManager.success("Abandoned Cart record updated successfully.");
    }
        
    if( nextProps.updatedAbandonedCartLeadError && this.props.updatedAbandonedCartLeadError !== nextProps.updatedAbandonedCartLeadError){
      NotificationManager.error("An error occurred while updating the notes");      
    }


  };


  items = [{ title: "Lead Information", to: "/lead" }];


  tableHeaderAbandonedCartCustomersColumnData = [
    {
      dataField: 'pet_id', text: 'Pet ID', sort: true, formatter: (cell, row) => {
        return (
          <span className="m-topbar__userpic">
            <img src={process.env.REACT_APP_S3_PATH + '/' + row.avatar_path + '/' + row.avatar_file_name} className="m--img-rounded m-width-50 mr-2" alt="" />
            <span className="m-badge m-badge--info mx-auto my-0 px-2">
            <strong>
              <a
                href={ `${process.env.REACT_APP_API_ENDPOINT}/core/medicalrecord/pdf/${this.props.data.petShopReducer.currentPetshop.id }/${row.MedicalRecord.id}`}
                target="_blank"  
                style={{ color:"#ffff"}}      
               >
               {cell}
              </a>
            </strong>
            </span> 
          </span>
        )
      }
    },
    {
      dataField: "firstname",
      text: "First Name",
      sort: true
    },
    {
      dataField: "lastname",
      text: "Last Name",
      sort: true

    },
    {
      dataField: "phone_number",
      text: "Phone Number",
      formatter: (cell, row) => (
        <a href={`tel:${cell}`} className="hyperlink-phone-number">
          {formatPhoneNumber(cell)}
        </a>
      ),    
    },
    {
      dataField: "email_address",
      text: "Email Address",
      sort: true,
      formatter : (cell,row) => <a href={`mailto:${cell}?body=Hello, ${convertToTitleCase(row.firstname)}!`} className="hyperlink">{cell}</a>

    },
    {
      dataField: "submitedDate",
      text: "Submitted Date",
      sort: true

    },
    {
      dataField: 'isSubscribed',
      text: 'Subscribed',
      sort: true,
      formatter: (cell, row) => {
        return (       
               cell == true ?  
                <span className="m-badge mx-auto my-0 px-2 m-badge--success">       
                  <strong>Yes</strong>                   
                </span>:
                <span className="m-badge mx-auto my-0 px-2 m-badge--danger">
                 <strong> No</strong> 
                </span>               
              );
      }
    },  
    {
      dataField: 'notes',
      text: 'Notes',
      sort: true,
      formatter: (cell, row) => {
        return ( 
          <div
           className=''       
          >
          <a
           href=""
           onClick={(e) => {this.openNotesEditModal(e,row)}}
           style ={{ color : "#575962" }}
          > 
             {cell}
             <i className="la la-edit"></i>
          </a>
        </div>
        );
      }
    },
  ];

  tableHeaderSubsCribedCustomersColumnData = [
    {
      dataField: 'pet_id', text: 'Pet ID', sort: true, formatter: (cell, row) => {
        return (
          <span className="m-topbar__userpic">
            <img src={process.env.REACT_APP_S3_PATH + '/' + row.avatar_path + '/' + row.avatar_file_name} className="m--img-rounded m-width-50 mr-2" alt="" />
            <span className="m-badge m-badge--info mx-auto my-0 px-2">
            <strong>
              <a
                href={ `${process.env.REACT_APP_API_ENDPOINT}/core/medicalrecord/pdf/${this.props.data.petShopReducer.currentPetshop.id }/${row.MedicalRecord.id}`}
                target="_blank"  
                style={{ color:"#ffff"}}      
               >
               {cell}
              </a>
            </strong>
            </span> 
          </span>
        )
      }
    },
    {
      dataField: "firstName",
      text: "First Name",
      sort: true
    },
    {
      dataField: "mobileNo",
      text: "Phone Number",
      formatter: (cell, row) => (
        <a href={`tel:${cell}`} className="hyperlink-phone-number">
            {formatPhoneNumber(cell)}
        </a>
      ),    
    },
    {
      dataField: "submitedDate",
      text: "Submitted Date",
      sort: true

    },
  ];

  tableAvailablePetsHecaderColumnData = [
    {
      dataField: "pet_id",
      text: "Pet ID",
      sort: true,
      formatter: (cell, row) => {
        return (
          <span className="m-topbar__userpic">
            <img
              src={
                process.env.REACT_APP_S3_PATH +
                "/" +
                row.avatar_path +
                "/" +
                row.avatar_file_name
              }
              className="m--img-rounded m-width-50 mr-2"
              alt=""
            />
            <span className="m-badge m-badge--info mx-auto my-0 px-2">
              <strong>{cell}</strong>
            </span>
          </span>
        );
      }
    },
    {
      dataField: "Breed.breed_type",
      text: "Breed",
      sort: true
    },
    {
      dataField: "sex",
      text: "Gender",
      sort: true,
      formatter: cell => cell
    },    
    { 
      dataField : "abandonedCartSubscriberCount",
      text : "Abandoned",
      sort: true
    } 
  ];

  changeTab = (tabName) => {
    this.setState({ selectedTab:tabName }); 
  }

  findPet = event => { 
    this.setState({ petIdInput: event.target.value });
    const selected = this.state.availablePets.find(e => {
      return e.pet_id === event.target.value;
    }); 
    if (selected) {
      this.setState({ selectedPetId: selected.pet_id, isLoadingAbandonedCartCustomers: true, isLoadingSubscribedCustomers: true, });
      this.props.getAbandonedCartCustomersViaMedicalRecord(selected.id);
      this.props.getSubscribedCustomersViaMedicalRecordId(selected.id);
    } else {
      this.setState({ selectedPetId: "" });
    }
 
  };

  changeVal = event => {
    let value = event.target.value;
    this.setState({
      ...this.state,
      [event.target.name]: value
    });
  };


  rowEvents = {
    onClick: (e, row, rowIndex) => { 
     if(row){    
        this.setState( {selectedPetId : row.pet_id, selectedMedicalRecordId : row.id, petIdInput :  row.pet_id } );
        $("#confirm_select_modal").modal("show"); 
      }
    }
  }


  fetchLeadInformation = () => {
    let medicalRecordId = this.state.selectedMedicalRecordId;
    this.setState({ isLoadingAbandonedCartCustomers: true, isLoadingSubscribedCustomers: true, })
    this.props.getAbandonedCartCustomersViaMedicalRecord(medicalRecordId);
    this.props.getSubscribedCustomersViaMedicalRecordId(medicalRecordId);
    $("#recent-medical-record-modal").modal("hide"); 
    $("#confirm_select_modal").modal("hide"); 

  }

  openNotesEditModal = (e,row) => {
    e.preventDefault();
    let notes = row.notes ? row.notes : "";
    this.setState({ abandonedCartId : row.id, abandonedCartNotes : notes });
    $("#notes-edit-modal").modal("show"); 

  }

  submitNotes = () => {
      let abandonedCartId = this.state.abandonedCartId;
      let data = {
        notes : this.state.abandonedCartNotes
      }
     this.props.updateAbandonedCartLeadInfo(abandonedCartId,data);
  }

  
  changeVal = event => {
    let value = event.target.value;
    this.setState({
      ...this.state,
      [event.target.name]: value
    });
  };



  render() {
    const {    
      selectedTab,
      availablePets,
      selectedPetId,
      abandonedCartCustomers,
      subscribedCustomers,
      searchedMedicalRecords,
      petIdInput,
      isLoadingAvailablePuppy,
      isLoadingAbandonedCartCustomers,
      isLoadingSubscribedCustomers,
      petId,
      abandonedCartNotes,
    } = this.state;

    return (
      <div className="m-grid m-grid--hor m-grid--root m-page">
        <div className="m-grid__item m-grid__item--fluid m-grid m-grid--hor-desktop m-grid--desktop m-body body-background">
          <BreadCrumb items={this.items} />
          <div className="m-grid__item m-grid__item--fluid  m-grid m-grid--ver	m-container m-container--responsive m-container--xxl m-page__container">
            <div className="m-grid__item m-grid__item--fluid m-wrapper">
              <div className="m-portlet m-portlet--mobile">
                {/* Start: Page Header */}
                <div className="m-portlet__head notification-action-btn-set">
                  <div className="m-portlet__head-caption">
                    <div className="m-portlet__head-title">
                      <h3 className="m-portlet__head-text">
                        Lead Information
                        <small>List of all leads</small>
                      </h3>
                    </div>
                  </div>
                  <div className="notification-manager-button-container">             
                    <div className="m-portlet__head-tools notification-refresh-btn"> 
                      <ul class="nav nav-pills nav-pills--brand m-nav-pills--align-right m-nav-pills--btn-pill m-nav-pills--btn-sm" role="tablist">
                        <li class="nav-item m-tabs__item">
                          <input
                            type="text"
                            onChange={evt => this.findPet(evt)}
                            placeholder="Enter Pet ID "
                            className="form-control m-input"
                            value={petIdInput}
                          />  
                        </li>
                        <li class="nav-item m-tabs__item">
                            <button 
                              type="button" 
                              className="btn btn-outline-success m-btn m-btn--icon m-btn--icon-only mt-1"
                              data-toggle="modal"
                              data-target="#recent-medical-record-modal"
                              >
                              <i className="far fa-eye"></i> 
														</button>               
                        </li>
                      </ul>          
                    </div>         
                  </div> 
                </div>
                {/* End: Page Header */}

                {/* Start: Page Body */}
                <div className="m-portlet__body">
                  <ul
                    className="nav nav-pills nav-pills--success m-nav-pills--btn-pill m-nav-pills--btn"
                    role="tablist"
                  >
                    <li className="nav-item m-tabs__item">
                      <button
                        className={classnames({
                          "nav-link m-tabs__link pl-4 pr-4 btn m-btn--pill btn-secondary m-btn m-btn--custom m-border-color-none": true,
                          active: selectedTab === "AbandonedCart",
                        })}                  
                        onClick={() => this.changeTab("AbandonedCart") }
                      >
                        Abandoned Cart
                      </button>
                    </li>
                    <li className="nav-item m-tabs__item">
                      <button
                        className={classnames({
                          "nav-link m-tabs__link pl-4 pr-4 btn m-btn--pill btn-secondary m-btn m-btn--custom m-border-color-none": true,
                          active: selectedTab === "SubscribedCustomers",
                        })}                  
                         onClick={() => this.changeTab("SubscribedCustomers") }
                      >
                        Subscribe To Pet
                      </button>
                    </li>
                    {/* <li className="nav-item m-tabs__item">
                      <button
                        className={classnames({
                          "nav-link m-tabs__link pl-4 pr-4 btn m-btn--pill btn-secondary m-btn m-btn--custom m-border-color-none": true,
                          active: selectedTab === "Quiz",
                        })}                 
                       onClick={() => this.changeTab("Quiz") }
                      >
                        Quiz
                      </button>
                    </li> */}
                  </ul>         
                 { selectedTab == LeadType.abandonedCart &&
                  <>
                  { !isLoadingAbandonedCartCustomers ?
                  <ToolkitProvider
                    keyField="id"
                    data={abandonedCartCustomers}
                    columns={ this.tableHeaderAbandonedCartCustomersColumnData}   
                    search
                    filter={filterFactory()}
                  >
                    {(props) => (
                      <div>
                        <div className="px-0 mb-4 search-bar">
                          <div className="col-lg-3 px-0 inner-addon right-addon m--align-right">
                            <i className="fas fa-search mt-1"></i>
                            <SearchBar {...props.searchProps} />
                          </div>
                        </div>
                        <div className="mb-2">
                          <small className="small-text">
                            *If you experience any difficulty in viewing the messaging campaigns, please make sure your
                            cache is cleared and completed a hard refresh. IOS users might have to use a private window.
                          </small>
                        </div>
                        <BootstrapTable classes="petTable" {...props.baseProps} pagination={paginationFactory()} />
                      </div>
                    )}                    
                  </ToolkitProvider>:
                    <div className="center-row">
                      <Loader size={50} />
                    </div>
                   }
                  </>
                 }
                 { selectedTab == LeadType.subscribedCustomers &&
                  <>
                  { !isLoadingSubscribedCustomers ?
                  <ToolkitProvider
                    keyField="id"
                    data={subscribedCustomers}
                    columns={this.tableHeaderSubsCribedCustomersColumnData}   
                    search
                    filter={filterFactory()}
                  >
                    {(props) => (
                      <div>
                        <div className="px-0 mb-4 search-bar">
                          <div className="col-lg-3 px-0 inner-addon right-addon m--align-right">
                            <i className="fas fa-search mt-1"></i>
                            <SearchBar {...props.searchProps} />
                          </div>
                        </div>
                        <div className="mb-2">
                          <small className="small-text">
                            *If you experience any difficulty in viewing the messaging campaigns, please make sure your
                            cache is cleared and completed a hard refresh. IOS users might have to use a private window.
                          </small>
                        </div>
                        <BootstrapTable classes="petTable" {...props.baseProps} pagination={paginationFactory()} />
                      </div>
                    )}                    
                  </ToolkitProvider>:
                    <div className="center-row">
                     <Loader size={50} />
                   </div>
                  }
                  </>
                 }
                </div>
                {/* End: Page Body */}
              </div>
            </div>
          </div>  
          {/* Available puppy modal start   */}
          <div className="modal fade show" id="recent-medical-record-modal" tabIndex="-1" role="dialog">
          <div className="modal-dialog modal-lg" role="document">
            <div className="modal-content modal-scrollable-dialog">         
                  <div className="modal-header">
                    <h5 className="modal-title" id="exampleModalLabel">Available Medical Records</h5>
                    <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                      <span aria-hidden="true">×</span>
                    </button>
                  </div>
                  <div className="modal-body modal-scrollable-body">                    
                      <div className="row">
                        <div className="col-xl-12">
                         { !isLoadingAvailablePuppy ?
                            <ToolkitProvider 
                            keyField="id"
                            data={availablePets}                      
                            columns={this.tableAvailablePetsHecaderColumnData}
                            search
                            defaultSortDirection="asc" 
                            hover={true} 
                            filter={ filterFactory() } 
                          >
                            {
                              props => (
                                <div>
                                  <div className='px-0 mb-4 search-bar'>
                                    <div className='col-lg-3 px-0 inner-addon right-addon'>
                                    <i className="fas fa-search"></i>
                                    <SearchBar {...props.searchProps} />
                                    </div>
                                  </div>
                                  <BootstrapTable
                                    classes="petTable"
                                    {...props.baseProps}
                                    pagination={ paginationFactory() } 
                                    hover
                                    rowEvents={this.rowEvents}    
                                    rowClasses = {"contract-recent-medicalrecord-search-hover-row"}                           
                                  />
                                </div>
                              )
                            }
                            </ToolkitProvider> :                   
                            <div className="center-row">
                              <Loader size={50} />
                            </div>
                        }
                        </div>
                      </div>
                  </div>
                  <div className="modal-footer">
                    { !isLoadingAvailablePuppy ? 
                      <div>
                        <button type="button" className="btn btn-secondary m-btn--pill mx-2" data-dismiss="modal">Close</button>
                        <button type="submit" className="btn btn-primary m-btn--pill">Submit</button>
                      </div>
                      :
                      <div className="center-row">
                        <Loader size={50} />
                      </div>
                    }
                  </div>          
            </div>
          </div>
          </div>   
          {/* Available puppy modal end */}
          {/* Select confirmation modal start */}
          <div className="modal fade show" id="confirm_select_modal" tabIndex="-1" role="dialog">
           <div className="modal-dialog" role="document">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title" id="exampleModalLabel">Confirm the puppy</h5>
                  <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>
                <div className="modal-body">
                  <p>Are you sure you want to select this puppy(<strong>{ this.state.selectedPetId }</strong>)?</p> 
                </div>
                <div className="modal-footer">              
                  <div>
                    <button type="button" className="btn btn-secondary m-btn--pill mx-2" data-dismiss="modal">Cancel</button>
                    <button type="button" onClick={() => this.fetchLeadInformation()} className="btn btn-primary m-btn--pill">Confirm</button>
                  </div>                   
                </div>
              </div>
           </div>
          </div>  
          {/* Select confirmation modal end */}
          {/* Abandoned cart notes edit start */}
          <div className="modal fade show" id="notes-edit-modal" tabIndex="-1" role="dialog">
           <div className="modal-dialog" role="document">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title" id="exampleModalLabel">Edit Notes</h5>
                  <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>
                <div className="modal-body">
                  <div className="form-group m-form__group">
										<label for="exampleTextarea">Notes</label>
										<textarea 
                      className="form-control m-input m-input--air" 
                      id="abandonedCartNotes"
                      rows="3"                
                      name="abandonedCartNotes"
                      onChange={this.changeVal}   
                      placeholder=""
                      value={abandonedCartNotes}                    
                    >
                    </textarea>
									</div>
                </div>
                <div className="modal-footer">              
                  <div>
                    <button type="button" className="btn btn-secondary m-btn--pill mx-2" data-dismiss="modal">Cancel</button>
                    <button type="button" onClick={() => this.submitNotes()} className="btn btn-primary m-btn--pill">Submit</button>
                  </div>                   
                </div>
              </div>
           </div>
         </div>
          {/* Abandoned cart notes edit end */}
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  data: state,
  leadsAvailablePets : state.medicalRecordsReducer.leadsAvailablePets,
  abandonCustomers : state.customersReducer.abandonCustomers,
  leadSubscribedCustomers : state.subscribeToPetReducer.leadSubscribedCustomers,
  abandonCustomersError : state.customersReducer.abandonCustomersError,
  leadSubscribedCustomersError : state.subscribeToPetReducer.leadSubscribedCustomersError,
  updatedAbandonedCartLead : state.customersReducer.updatedAbandonedCartLead,
  updatedAbandonedCartLeadError : state.customersReducer.updatedAbandonedCartLeadError,
 
});

const mapDispatchToProps = (dispatch) => ({

  getAvailablePets: () => {
    dispatch(getAvailablePets());
  },
  getAbandonedCartCustomersViaMedicalRecord:(id)=>{
    dispatch(getAbandonedCartCustomersViaMedicalRecord(id));
  },
  getSubscribedCustomersViaMedicalRecordId:(id)=>{
    dispatch(getSubscribedCustomersViaMedicalRecordId(id));
  },
  updateAbandonedCartLeadInfo: (id,data) => {
    dispatch(updateAbandonedCartLeadInfo(id,data));
  }
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(LeadInformationsList));
